$('.js-btn-scroll').on('click', function(e) {
	e.preventDefault();
	const scrollData = $(this).data('scroll');
	if ($(scrollData).length) {
		$('html, body').animate({ scrollTop: $(scrollData).offset().top }, 500);
	}
});
